"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// cookie names & storage names
exports.default = {
    LANG_COOKIE: 'language',
    AUTH_COOKIE: 'ltoken',
    PAYMENT_COOKIE: 'ptoken',
    OUR_CARS: 'isOurCarDialogSeen',
    DOCUMENT: 'isDocumentInfoDialogSeen',
    FLEET_QUOTE: 'fleetQuote',
    CREATE_PROFILE: 'isCreateProfileDialogSeen',
    ACTIVE_TAB: 'activeTab',
    RENTAL_FEEDBACK: 'isRentalFeedbackSeen',
    RENTAL_FEEDBACK_TIMESTAMP: 'rentalFeedbackTimestamp',
    RECENT_SEARCH: 'recentSearch',
    CARD_DETAILS_SAVED: 'cardDetailsSaved',
    SHOW_SAVE_CARD_DETAILS: 'showSaveCardDetails',
    UNLIMITED_KM: 'isUnlimitedKmSeen',
    EXTENSION_DETAILS: 'extensionInApp',
    SAVE_CARD_FOR_FUTURE_PAYMENT: 'saveCardForFuturePayment', // add comment
};
